<router-outlet></router-outlet>


<div *ngIf="busyMessage" class="blocking-overlay">
    <!-- <p>Sto Google Drive</p> -->
  <!-- <small>{{busyMessage}}</small> -->
  <p>{{busyMessage}}</p>
</div>
        
<!-- <router-outlet name="contact"></router-outlet> -->